import { Component, OnInit, AfterViewChecked, Input } from '@angular/core';
import * as jQuery from 'jquery';
import * as _ from 'underscore';
import * as numeral from 'numeral';

import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { PATHS } from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-quick-stats-r5',
	templateUrl: './quick-stats-r5.component.html',
	styleUrls: ['./quick-stats-r5.component.css']
})
export class QuickStatsR5Component implements OnInit, WidgetCore, AfterViewChecked {
	@Input() legend: any;
	@Input() columnsconfig: any;
	@Input() iscustomendpoint: any;
	@Input() uniqueoverwriteid: string;
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrowSize: 'small',
		distance: -8,
		offset: 0,
		arrow: true,
		size: 'small',
		duration: 750,
		scale: 'small',
		dynamicTitle: true,
		theme: 'dark-theme'
	};
	public key: string;
	public sectiontitle: string;
	public tempAvgPositionAvail: boolean = false;
	public sectionclass: string;
	public showRate: boolean = false;
	public isR11: boolean = false;
	public isR9: boolean = false;
	public isR702: boolean = false;
	public isEmail;
	boolean = false;
	title: string;
	color: any;
	public showLoad = true;
	public hasData = true;
	public reloadSubscription;
	public widgetDataSubscription;
	public quickStatsData = [];
	public range: string;
	templegend: any;
	isGoliveNotStarted: boolean;
	isCutoffDate: boolean;
	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit() {
		this.legend = JSON.parse(decodeURI(this.legend));
		this.legend = this.legend.filter((legend) => this.analyticsDataModel.checkComponentForPermission(legend));
		this.columnsconfig = JSON.parse(decodeURI(this.columnsconfig));
		this.isR11 = this.analyticsDataModel.config.version.includes('R11');
		this.isR9 = this.analyticsDataModel.config.version.includes('R9');
		this.isR702 = this.analyticsDataModel.config.directoryName == 'default-r702';
		this.isEmail = this.analyticsDataModel.getCurrentPath() == 'email';
		if (this.isR9) {
			this.tooltipOptions.theme = 'light';
		}
		this.requestData();
		for (let i = 0; this.legend.legth - 1; i++) {
			if (this.legend[i].value == 'avg_position') {
				this.tempAvgPositionAvail = true;
				break;
			}
		}
	}

	requestData() {
		this.hasData = true;
		this.showLoad = true;
		// this.range = this.analyticsService.checkDateRange(this.analyticsService.deprecated_date_avg_position);
		this.analyticsService.checkDateRange();
		this.isGoliveNotStarted = this.analyticsService.isGoliveNotStarted;
		this.isCutoffDate = this.analyticsService.isCutoffDate;
		if (this.iscustomendpoint == 'true') {
			this.widgetDataSubscription = this.analyticsService
				.processCustomServiceRequest(this.key, null, null, null, null, this.uniqueoverwriteid)
				.subscribe((res: any) => {
					this.showLoad = false;
					let res_data = res.success ? res.data[0] : [];
					this.hasData = res.success;
					this.processResponseData({ ...res_data });
				});
		} else {
			this.widgetDataSubscription = this.analyticsService
				.processWidgetRequest(this.key, this.columnsconfig, null, this.uniqueoverwriteid)
				.subscribe((res: any) => {
					this.showLoad = false;
					let res_data = res.success ? res.data[0] : [];
					this.hasData = res.success;
					this.processResponseData({ ...res_data });
				});
		}
	}

	processResponseData(response) {
		const responseKeys = Object.keys(response);
		if (this.isCutoffDate) {
			this.templegend = this.legend.filter((element) => element['displayName'] != 'Avg. Position');
		} else if (this.isGoliveNotStarted) {
			this.templegend = this.legend.filter((element) => element['displayName'] != 'Absolute Top Impression');
		} else if (!this.isCutoffDate || !this.isGoliveNotStarted) {
			this.templegend = this.legend;
		}

		//filtering legend by permission
		this.templegend = _.filter(this.templegend, (item) => {
			return this.analyticsDataModel.checkComponentForPermission(item);
		});

		this.quickStatsData = _.map(this.templegend, (templegend, index) => {
			if (response[templegend['value']]) {
				let hasPercent =
					responseKeys.includes(`${templegend['value']}_rate`) ||
					responseKeys.includes(`${templegend['value']}_percent`);
				let percent_value = hasPercent
					? numeral(
							response[`${templegend['value']}_rate_impression_viewed`] ||
								response[`${templegend['value']}_rate`] ||
								response[`${templegend['value']}_percent`]
					  ).format('0,0.00') + '%'
					: '';

				const currentProduct = this.analyticsDataModel.getCurrentPath();
				//  remove the click rate % only for SEM for rendering in UI
				if (currentProduct === PATHS.SEM) {
					hasPercent = false;
					if (templegend['displayName'] == 'Click Rate') {
						response[templegend['value']] =
							numeral(response[`${templegend['value']}`] || response[`${templegend['value']}`]).format('0,0.00') + '%';
					}
				}
				if (currentProduct === PATHS.CTV || currentProduct === PATHS.OTT) {
					if (templegend['displayName'] === 'Completions' && this.analyticsDataModel.config.version.includes('R11')) {
						hasPercent = false;
					}
					if (templegend['displayName'] == 'Completion Rate') {
						hasPercent = this.analyticsDataModel.config.version.includes('R5') ? true : false;
						response[templegend['value']] =
							numeral(response[`${templegend['value']}`] || response[`${templegend['value']}`]).format('0,0.00') + '%';
					}
				}

				if (currentProduct === PATHS.RADIO) {
					if (templegend['displayName'] === 'Completions') {
						hasPercent = this.analyticsDataModel.config.version.includes('R5') ? true : false;
					}
					if (templegend['displayName'] === 'Completion Rate') {
						response[templegend['value']] =
							numeral(response[`${templegend['value']}`] || response[`${templegend['value']}`]).format('0,0.00') + '%';
					}
				}

				if (currentProduct === PATHS.SOCIAL || currentProduct === PATHS.RESPONSIVE_DISPLAY) {
					if (templegend['displayName'] === 'Clicks' && this.analyticsDataModel.config.version.includes('R11')) {
						hasPercent = false;
					}
					if (
						(templegend['displayName'] === 'Click Rate' || templegend['displayName'] === 'CTR') &&
						(this.analyticsDataModel.config.version.includes('R11') ||
							this.analyticsDataModel.config.version.includes('R9'))
					) {
						response[templegend['value']] =
							numeral(response[`${templegend['value']}`] || response[`${templegend['value']}`]).format('0,0.00') + '%';
					}
				}

				// remove the rate metrics from quickstats R11
				if (currentProduct === PATHS.OVERVIEW) {
					this.showRate = this.analyticsDataModel.config.version.includes('R11') ? true : false;
				}

				if (response[templegend['value']] == '0') {
					return {
						name: templegend['displayName'],
						value: '0',
						hasPercent: hasPercent,
						percent_value: percent_value,
						title: templegend['title']
					};
				}
				return {
					name: templegend['displayName'],
					value: Number(response[templegend['value']].split(',').join('')) || response[templegend['value']],
					hasPercent: hasPercent,
					percent_value: percent_value,
					title: templegend['title']
				};
			} else {
				return {
					name: templegend['displayName'],
					value: '',
					title: templegend['title']
				};
			}
		});
		if (this.isCutoffDate && this.analyticsDataModel.getCurrentPath() === PATHS.SEM) {
			this.quickStatsData.push({
				name: '',
				value: '',
				title: ''
			});
		}
	}

	public ngAfterViewChecked(): void {
		jQuery('.arrow-small').css({
			position: 'absolute',
			left: this.analyticsDataModel.config.directoryName.includes('r702') ? '47%' : '1%'
		});
		jQuery('.tippy-tooltip').css({ 'text-align': 'left' });
		if (window.matchMedia('(max-width: 768px)').matches) {
			jQuery('.tippy-popper').css('width', '135px');
		} else if (window.matchMedia('(max-width: 1024px)').matches) {
			jQuery('.tippy-popper').css('width', '180px');
		} else if (window.matchMedia('(max-width: 1366px)').matches) {
			jQuery('.tippy-popper').css('width', '210px');
		} else if (window.matchMedia('(max-width: 1600px)').matches) {
			jQuery('.tippy-popper').css('width', '220px');
		} else if (window.matchMedia('(max-width: 1920px)').matches) {
			jQuery('.tippy-popper').css('width', '310px');
		}
	}
}
